import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["tab", "section"]
  }

  static get values() {
    return { urlParam: { type: String, default: "" } }
  }

  connect() {
    if (this.urlParamValue && this.urlParamValue.length > 0) {
      const savedTab = this.getTabFromURL()
      if (savedTab) {
        this.selectTab(savedTab)
      }
    }
  }

  changeTab(event) {
    const value = event.currentTarget.dataset.value
    this.selectTab(value)

    if (this.urlParamValue && this.urlParamValue.length > 0) {
      this.updateURL(value)
    }
  }

  selectTab(value) {
    this.tabTargets.forEach((tab) => {
      if (tab.dataset.value === value) {
        tab.setAttribute("aria-selected", "true")
      } else {
        tab.setAttribute("aria-selected", "false")
      }
    })

    this.sectionTargets.forEach((section) => {
      if (section.dataset.value === value) {
        section.classList.remove("d-none")
      } else {
        section.classList.add("d-none")
      }
    })
  }

  getTabFromURL() {
    const params = new URLSearchParams(window.location.search)
    return params.get(this.urlParamValue)
  }

  updateURL(value) {
    const params = new URLSearchParams(window.location.search)
    params.set(this.urlParamValue, value)
    const newURL = `${window.location.pathname}?${params.toString()}`
    window.history.replaceState(null, "", newURL)
  }
}
